import { useState } from 'react'
import { Link } from 'react-router-dom'
import ScrollToTopButton from '@components/common/ScrollToTopButton'
import { PageHero, Reveal, Icon, ICONS, CtaBand, NAVY, GOLD_ICON, GOLD } from '@components/marketing'

const SECTIONS = [
  { id: 'general', name: 'Questions générales', icon: 'question' },
  { id: 'account', name: 'Compte & profil', icon: 'user' },
  { id: 'publish', name: 'Publication', icon: 'pencil' },
  { id: 'payment', name: 'Paiement', icon: 'card' },
  { id: 'security', name: 'Sécurité', icon: 'lock' },
  { id: 'contact', name: 'Contact', icon: 'chat' },
]

const FAQS = {
  general: [
    { question: 'Qu\'est-ce que KUDHI ?', answer: 'KUDHI est une plateforme de mise en relation qui connecte vendeurs et acheteurs, entreprises et particuliers. Publiez vos annonces (images, vidéos, bannières), recherchez des produits et services, et échangez directement avec les vendeurs.' },
    { question: 'Comment utiliser KUDHI ?', answer: 'Inscrivez-vous gratuitement, complétez votre profil, puis publiez vos annonces ou parcourez celles des autres. Vous pouvez filtrer par catégorie et rechercher par mot-clé.' },
    { question: 'KUDHI est-il gratuit ?', answer: 'L\'inscription et la consultation des annonces sont gratuites. Une période d\'essai vous permet de publier sans payer ; ensuite, chaque annonce est payée une seule fois, pour la durée de votre choix. Consultez la page Tarification pour le détail.' },
    { question: 'Dans quelles régions KUDHI est-il disponible ?', answer: 'KUDHI est disponible dans toute la Côte d\'Ivoire, sur le web et sur l\'application mobile Android et iOS.' },
  ],
  account: [
    { question: 'Comment créer un compte ?', answer: 'Cliquez sur « S\'inscrire » en haut de la page, renseignez vos informations (nom, email, téléphone) et créez un mot de passe. Sur l\'application mobile, un code de vérification vous est envoyé par email pour confirmer votre inscription.' },
    { question: 'J\'ai oublié mon mot de passe', answer: 'Cliquez sur « Mot de passe oublié » sur la page de connexion, puis suivez les instructions : vous recevrez un code pour définir un nouveau mot de passe.' },
    { question: 'Comment modifier mes informations personnelles ?', answer: 'Accédez à votre profil en cliquant sur votre photo, puis modifiez vos informations et votre photo de profil.' },
    { question: 'Comment supprimer mon compte ?', answer: 'Vous pouvez demander la suppression de votre compte depuis l\'application ou en contactant le support. Votre compte est d\'abord archivé, puis supprimé définitivement après 30 jours.' },
  ],
  publish: [
    { question: 'Comment publier une annonce ?', answer: 'Cliquez sur le bouton « + », choisissez le format (Images, Vidéo ou Bannière), remplissez les informations, ajoutez vos médias, choisissez la durée de diffusion puis validez.' },
    { question: 'Combien de photos puis-je ajouter ?', answer: 'Une annonce Images peut contenir 3, 6 ou 9 photos selon la formule choisie. La première photo est utilisée comme image principale.' },
    { question: 'Comment modifier ou supprimer mon annonce ?', answer: 'Rendez-vous dans votre espace, retrouvez l\'annonce concernée, puis utilisez les options de modification, d\'archivage ou de suppression.' },
    { question: 'Combien de temps mon annonce reste-t-elle en ligne ?', answer: 'Vous choisissez la durée au moment de la publication : 1 jour, 3 jours, 1 semaine ou 1 mois. À la fin, vous pouvez la republier quand vous le souhaitez.' },
    { question: 'Quelles sont les règles de publication ?', answer: 'Les annonces doivent être honnêtes et illustrées de photos réelles. Les produits interdits, les contrefaçons et les contenus inappropriés sont refusés lors de la modération.' },
  ],
  payment: [
    { question: 'Quels sont les moyens de paiement acceptés ?', answer: 'Le paiement des annonces se fait par Wave, directement depuis votre téléphone. Orange Money et MTN Mobile Money arrivent bientôt.' },
    { question: 'Comment fonctionne le paiement entre acheteur et vendeur ?', answer: 'KUDHI ne gère pas les transactions entre utilisateurs. Le paiement se fait directement entre l\'acheteur et le vendeur, selon les modalités convenues entre eux.' },
    { question: 'Les transactions sont-elles sécurisées ?', answer: 'Nous recommandons de rencontrer les vendeurs dans des lieux publics et de vérifier les produits avant de payer. Méfiez-vous des offres trop alléchantes.' },
    { question: 'Puis-je obtenir un remboursement ?', answer: 'Pour toute question sur un paiement effectué sur KUDHI, contactez le support. Pour une transaction entre utilisateurs, adressez-vous directement au vendeur.' },
  ],
  security: [
    { question: 'Comment éviter les arnaques ?', answer: 'Rencontrez les vendeurs en personne, vérifiez les produits avant de payer, méfiez-vous des prix trop bas et ne payez jamais à l\'avance sans garantie.' },
    { question: 'Comment signaler une annonce suspecte ?', answer: 'Contactez le support en indiquant le lien de l\'annonce et la raison du signalement. Notre équipe l\'examinera rapidement.' },
    { question: 'Mes données personnelles sont-elles protégées ?', answer: 'Oui. Nous ne partageons jamais vos données personnelles avec des tiers sans votre consentement. Consultez notre politique de confidentialité pour en savoir plus.' },
    { question: 'Que faire en cas de fraude ?', answer: 'Contactez immédiatement le support et signalez l\'utilisateur. Si un paiement est en jeu, contactez également les autorités compétentes.' },
  ],
  contact: [
    { question: 'Comment contacter le support ?', answer: 'Écrivez-nous à info@kudhi.net, appelez le +225 05 06 76 77 17, ou utilisez le formulaire de la page Contact.' },
    { question: 'Quel est le délai de réponse du support ?', answer: 'Nous nous efforçons de répondre à toutes les demandes dans un délai de 24 à 48 heures ouvrables.' },
  ],
}

const CONTACTS = [
  { icon: 'mail', label: 'Email', value: 'info@kudhi.net', href: 'mailto:info@kudhi.net' },
  { icon: 'call', label: 'Téléphone', value: '+225 05 06 76 77 17', href: 'tel:+2250506767717' },
  { icon: 'pin', label: 'Adresse', value: 'Grand Bassam, Côte d\'Ivoire' },
]

const normalize = (s) => s.toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '')

function HelpPage() {
  const [activeSection, setActiveSection] = useState('general')
  const [searchQuery, setSearchQuery] = useState('')
  const [expanded, setExpanded] = useState(0)

  const query = normalize(searchQuery.trim())
  const results = query
    ? Object.values(FAQS).flat().filter((f) => normalize(f.question).includes(query) || normalize(f.answer).includes(query))
    : FAQS[activeSection]

  const selectSection = (id) => {
    setActiveSection(id)
    setSearchQuery('')
    setExpanded(0)
  }

  return (
    <div className="home-font bg-white text-slate-900 overflow-x-hidden">
      <PageHero
        badge="Centre d'aide"
        badgeIcon="question"
        title="Comment pouvons-nous"
        highlight="vous aider ?"
        subtitle="Trouvez rapidement une réponse à vos questions sur KUDHI."
      >
        <div className="relative mt-10 max-w-2xl mx-auto">
          <span className="absolute left-5 top-1/2 -translate-y-1/2 text-slate-400">
            <Icon d={ICONS.search} className="w-5 h-5" strokeWidth={2} />
          </span>
          <input
            type="search"
            value={searchQuery}
            onChange={(e) => { setSearchQuery(e.target.value); setExpanded(0) }}
            placeholder="Rechercher : paiement, photos, mot de passe…"
            className="w-full rounded-md border border-slate-200 bg-white py-4 pl-14 pr-5 text-base shadow-lg shadow-amber-100/60 placeholder:text-slate-400 focus:border-amber-300 focus:outline-none focus:ring-4 focus:ring-amber-100"
            style={{ color: NAVY }}
          />
        </div>
      </PageHero>

      <section className="pb-24 pt-4">
        <div className="w-[90%] md:w-[80%] mx-auto grid lg:grid-cols-[280px_1fr] gap-8 lg:gap-12">
          {/* Catégories */}
          <aside className="lg:sticky lg:top-28 self-start">
            <p className="hidden lg:block mb-3 text-sm font-bold uppercase tracking-widest text-slate-400">Catégories</p>
            <nav className="flex lg:flex-col gap-2 overflow-x-auto pb-2 lg:pb-0 -mx-1 px-1">
              {SECTIONS.map((s) => {
                const active = !query && activeSection === s.id
                return (
                  <button
                    key={s.id}
                    onClick={() => selectSection(s.id)}
                    className={`flex flex-shrink-0 items-center gap-3 whitespace-nowrap rounded-md px-4 py-3 text-sm font-semibold transition-all ${
                      active ? 'shadow-md' : 'text-slate-600 hover:bg-slate-50 border border-slate-200 lg:border-transparent'
                    }`}
                    style={active ? { background: NAVY, color: '#fff' } : {}}
                  >
                    <span className="flex h-8 w-8 items-center justify-center rounded-md" style={GOLD_ICON}>
                      <Icon d={ICONS[s.icon]} className="w-4 h-4" />
                    </span>
                    {s.name}
                    <span className={`ml-auto hidden lg:inline text-xs ${active ? 'text-white/60' : 'text-slate-400'}`}>{FAQS[s.id].length}</span>
                  </button>
                )
              })}
            </nav>
          </aside>

          {/* FAQ */}
          <div>
            <h2 className="text-2xl sm:text-3xl font-extrabold tracking-tight" style={{ color: NAVY }}>
              {query ? `${results.length} résultat${results.length > 1 ? 's' : ''} pour « ${searchQuery.trim()} »` : SECTIONS.find((s) => s.id === activeSection)?.name}
            </h2>

            {results.length > 0 ? (
              <div className="mt-6 space-y-3">
                {results.map((faq, i) => {
                  const open = expanded === i
                  return (
                    <div key={faq.question} className={`rounded-md border transition-all ${open ? 'border-amber-200 bg-amber-50/40 shadow-sm' : 'border-slate-200 bg-white hover:border-slate-300'}`}>
                      <button
                        onClick={() => setExpanded(open ? -1 : i)}
                        className="flex w-full items-center justify-between gap-6 px-6 py-5 text-left"
                        aria-expanded={open}
                      >
                        <span className="font-semibold" style={{ color: NAVY }}>{faq.question}</span>
                        <span className={`flex h-8 w-8 flex-shrink-0 items-center justify-center rounded-full transition-all ${open ? 'rotate-180' : ''}`} style={{ background: open ? GOLD : '#F1F5F9', color: NAVY }}>
                          <Icon d={ICONS.chevron} className="w-4 h-4" strokeWidth={2.5} />
                        </span>
                      </button>
                      <div className={`grid transition-all duration-300 ${open ? 'grid-rows-[1fr] opacity-100' : 'grid-rows-[0fr] opacity-0'}`}>
                        <p className="overflow-hidden px-6 text-slate-600 leading-relaxed">
                          <span className="block pb-5">{faq.answer}</span>
                        </p>
                      </div>
                    </div>
                  )
                })}
              </div>
            ) : (
              <div className="mt-6 rounded-md border border-dashed border-slate-300 px-6 py-16 text-center">
                <span className="mx-auto flex h-14 w-14 items-center justify-center rounded-md" style={GOLD_ICON}>
                  <Icon d={ICONS.search} />
                </span>
                <p className="mt-4 font-semibold" style={{ color: NAVY }}>Aucun résultat</p>
                <p className="mt-1 text-slate-500">Essayez un autre mot-clé ou contactez-nous directement.</p>
              </div>
            )}

            {/* Contact */}
            <Reveal className="mt-12 rounded-md bg-slate-50 p-7 sm:p-10">
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-6">
                <div>
                  <h3 className="text-2xl font-extrabold tracking-tight" style={{ color: NAVY }}>Vous ne trouvez pas votre réponse ?</h3>
                  <p className="mt-2 text-slate-600">Notre équipe vous répond rapidement.</p>
                </div>
                <Link
                  to="/contact"
                  className="group inline-flex items-center justify-center gap-2 whitespace-nowrap rounded-md px-6 py-3.5 font-bold text-white transition-all hover:-translate-y-0.5 hover:shadow-lg"
                  style={{ background: NAVY }}
                >
                  Nous écrire
                  <Icon d={ICONS.arrow} className="w-4 h-4 transition-transform group-hover:translate-x-1" strokeWidth={2.2} />
                </Link>
              </div>
              <div className="mt-8 grid sm:grid-cols-3 gap-3">
                {CONTACTS.map((c) => {
                  const content = (
                    <>
                      <span className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-md" style={GOLD_ICON}>
                        <Icon d={ICONS[c.icon]} className="w-5 h-5" />
                      </span>
                      <span className="leading-tight">
                        <span className="block text-xs text-slate-500">{c.label}</span>
                        <span className="block font-semibold" style={{ color: NAVY }}>{c.value}</span>
                      </span>
                    </>
                  )
                  return c.href ? (
                    <a key={c.label} href={c.href} className="flex items-center gap-3 rounded-md bg-white p-4 transition-shadow hover:shadow-md">{content}</a>
                  ) : (
                    <div key={c.label} className="flex items-center gap-3 rounded-md bg-white p-4">{content}</div>
                  )
                })}
              </div>
            </Reveal>
          </div>
        </div>
      </section>

      <CtaBand />

      <ScrollToTopButton />
    </div>
  )
}

export default HelpPage
